import React from 'react';
import { IMediaProps } from './IMediaProps';
import { DetailsIcon } from './DetailsIcon';
import { DetailsName } from './DetailsName';
import { DetailsSize } from './DetailsSize';
import classNames from 'classnames';
import { styled } from '@mui/material/styles';

export const Details = styled(
	({
		resource: { size, name, mime_type, resource_id },
		children,
		hideIcon,
		hideName,
		className,
		description,
		...props
	}: IMediaProps) => {
		return (
			<div className={classNames('message__details', className)} {...props}>
				{!hideIcon && <DetailsIcon mime_type={mime_type} />}
				<main className="details__main">
					<div className="details__primary">
						{!hideName && <DetailsName name={name ?? resource_id} />}
					</div>
					<div className="details__secondary">
						{size && <DetailsSize size={size} />}
						{description}
					</div>
				</main>
				{children}
			</div>
		);
	},
	{
		label: 'Details',
		target: 'Details-root',
	},
)({
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	maxWidth: '100%',

	gap: '0.5em',
	marginTop: '0.5em',
	color: 'var(--message__details_color)',
	'& .details__main': {
		display: 'flex',
		flexDirection: 'column',
		flexGrow: 1,
		flexShrink: 1,
		overflow: 'hidden',
	},
	'& .details__primary, & .details__secondary': {
		display: 'flex',
		flexDirection: 'row',
	},
	'& .details__primary': {
		overflow: 'hidden',
	},
	'& .details__secondary': {
		gap: '0.5em',
		flexWrap: 'wrap',
		fontSize: '1em',
		flexGrow: 1,
		flexShrink: 1,
		'& > *': {
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
			overflow: 'hidden',
		},
	},
	'& .details__icon': {
		height: '1.5em',
		width: '1.5em',
		flexShrink: 0,
		'& .st0': {
			fill: 'var(--message__details__icon_color)',
		},
	},
	'& .details__name': {
		flexGrow: 1,
		flexShrink: 1,
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		fontSize: '1.3em',
	},
});
